import React, { useEffect, useState } from 'react';
import "./style.css";
import { useNavigate, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { BASE_URL } from '../../constants';
import { userData } from '../../data/fake_login_data';
import { perms } from '../../data/side_nav_data';
import DefaultLayout from '../../layouts/defaultLayout';
import { Loader } from 'rsuite';
import { addition } from '../../assets/svgIcons';
import PageHeader from '../../components/page-header';

const CardsTempletes = () => {
  const [getParams] = useSearchParams();
  const navigate = useNavigate();
  const [newSrc, setNewSrc] = useState(null);
  const [cards, setCards] = useState(null);

  const getTemplates = async () => {
    const univsAndGradesChainsCoursesChapters = await axios.post(
      BASE_URL +
      "subscriptions/cards/design_templets/select_design_templets.php",
      {
        admin_id: userData?.user_id,
        access_token: userData?.access_token,
      }
    );
    setCards(univsAndGradesChainsCoursesChapters?.data?.message);
  };

  useEffect(() => {
    getTemplates();
  }, []);

  return (
    <DefaultLayout>
      <PageHeader
        title={"Card Templates"}
        description="Manage card templates and designs"
        addButton={(perms?.includes("*19_2") || perms?.startsWith("19_2")) ? "Create Template" : null}
        setShowAdd={() => navigate("/Cards")}
        exportButton={perms?.includes("*19_7") || perms?.startsWith("19_7")}
      />
      <>
        {/* <button 
          className="btn btn-primary create-button" 
          onClick={() => navigate("/Cards")}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            padding: '10px 20px',
            borderRadius: '8px',
            fontWeight: 'bold',
            transition: 'all 0.3s ease',
          }}
        >
          <span>{addition}</span>
          <span>Create Templates</span>
        </button> */}
        {(perms?.includes("*19_1") || perms?.startsWith("19_1")) ? (
          <div
            className="CardsPreview"
            style={{
              display: 'flex',
              flexWrap: 'wrap',
              justifyContent: 'center',
              gap: '20px',
              marginTop: '20px',
            }}
          >
            {!cards ? (
              <Loader />
            ) : (
              cards?.length &&
              cards.map((card, index) => {
              return (
                <div
                  className="cardImage"
                  key={index}
                  style={{
                    position: 'relative',
                    backgroundImage: `url(${card?.image_url})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    width: `${card?.card_width}px`,
                    height: `${card?.card_height}px`,
                    borderRadius: '12px',
                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
                    overflow: 'hidden',
                    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                  }}
                >
                  <div
                    className="previewOverLay"
                    style={{
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      width: '100%',
                      height: '100%',
                      backgroundColor: 'rgba(0, 0, 0, 0.6)',
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'center',
                      alignItems: 'center',
                      opacity: 0,
                      transition: 'opacity 0.3s ease',
                      color: 'white',
                      padding: '20px',
                      boxSizing: 'border-box',
                    }}
                  >
                    <span
                      style={{
                        fontSize: '18px',
                        fontWeight: 'bold',
                        marginBottom: '12px',
                        textAlign: 'center',
                      }}
                    >
                      {card?.templet_name}
                    </span>
                    {(perms?.includes("*19_6") || perms?.startsWith("19_6")) && (
                      <button
                        className="previewButton btn btn-success"
                        onClick={() => {
                          localStorage.setItem(
                            "cardsToken",
                            btoa(
                              JSON.stringify({
                                pos: {
                                  cardCode: {
                                    top: card?.code_top,
                                    left: card?.code_left,
                                    font: card?.code_fontsize,
                                  },
                                  cardId: {
                                    top: card?.id_top,
                                    left: card?.id_left,
                                    font: card?.id_fontsize,
                                  },
                                  cardImage: {
                                    width: card?.card_width,
                                    height: card?.card_height,
                                  },
                                },
                                src: card?.image_url,
                              })
                            )
                          );
                          window.open("/CardsPreview", "_blank");
                        }}
                        style={{
                          padding: '8px 16px',
                          borderRadius: '6px',
                          fontWeight: 'bold',
                          transition: 'background-color 0.3s ease',
                        }}
                      >
                        Preview
                      </button>
                    )}
                  </div>

                  <div>
                    <p
                      style={{
                        letterSpacing: '8px',
                        fontWeight: 'bold',
                        padding: '3px 4px',
                        fontSize: `${card?.code_fontsize}px`,
                        position: 'absolute',
                        top: `${card?.code_top}px`,
                        left: `${card?.code_left}px`,
                        margin: 0,
                        color: 'inherit', // Adjust based on design needs
                      }}
                    >
                      12287592286296
                    </p>

                    <p
                      style={{
                        color: 'black',
                        fontSize: `${card?.id_fontsize}px`,
                        position: 'absolute',
                        letterSpacing: '3px',
                        top: `${card?.id_top}px`,
                        left: `${card?.id_left}px`,
                        margin: 0,
                        width: 'fit-content',
                        textAlign: 'center',
                      }}
                    >
                      1701
                    </p>
                  </div>
                </div>
              );
            })
          )}
          </div>
        ) : (
          <div style={{
            textAlign: 'center',
            padding: '60px 20px',
            color: '#6b7280',
            fontSize: '18px',
            fontWeight: '500'
          }}>
            <p>You don't have permission to view card templates.</p>
          </div>
        )}
      </>
    </DefaultLayout>
  );
};

export default CardsTempletes;